import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArtigoGuiaCompleto from "../pages/artigo-guia-completo/page";
import ArtigoPage from "../pages/artigo/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/guia-completo-hoobuyspreadsheet-2026",
    element: <ArtigoGuiaCompleto />,
  },
  {
    path: "/artigo/:slug",
    element: <ArtigoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;